import { jsxs, jsx } from "@emotion/react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { addTrackingPrefix } from "../utils/addTrackingPrefix.js";
const ShareAccomplishment = ({
  setScreen
}) => {
  const {
    t
  } = useTranslation();
  return /* @__PURE__ */ jsxs("div", { children: [
    /* @__PURE__ */ jsx("h1", { children: t("ShareAccomplishmentPage.header") }),
    /* @__PURE__ */ jsx("p", { children: t("ShareAccomplishmentPage.message") }),
    /* @__PURE__ */ jsx("button", { "data-testid": "recommendations-screen", "data-trackid": addTrackingPrefix("recommendations-screen"), onClick: () => setScreen("recommendations"), children: t("ShareAccomplishmentPage.cta") })
  ] });
};
export {
  ShareAccomplishment
};
